var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input', {
    staticClass: "kwt-submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit($event);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }